import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface ChatGreetingProps {
  isVisible: boolean;
  onDismiss: () => void;
  onOpenChat: () => void;
}

const ChatGreeting = ({ isVisible, onDismiss, onOpenChat }: ChatGreetingProps) => {
  if (!isVisible) return null;

  return (
    <div
      className={cn(
        "fixed bottom-24 right-4 z-50 max-w-[280px] animate-chat-greeting-in",
        "bg-card text-card-foreground rounded-2xl shadow-xl border border-border",
        "cursor-pointer transition-transform hover:scale-[1.02]"
      )}
      onClick={onOpenChat}
    >
      {/* Close button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onDismiss();
        }}
        className="absolute -top-2 -right-2 w-6 h-6 bg-muted rounded-full flex items-center justify-center hover:bg-muted/80 transition-colors"
        aria-label="Dismiss greeting"
      >
        <X className="h-3 w-3 text-muted-foreground" />
      </button>

      {/* Message content */}
      <div className="p-4">
        <p className="text-sm font-medium leading-relaxed">
          Hi there! 👋 Got any questions about our pressure washing services?
        </p>
        <p className="text-xs text-muted-foreground mt-2">
          Click to chat with us
        </p>
      </div>

      {/* Speech bubble tail */}
      <div className="absolute -bottom-2 right-8 w-4 h-4 bg-card border-r border-b border-border rotate-45" />
    </div>
  );
};

export default ChatGreeting;
